// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lZwMU","newExpiryDate":"styles_newExpiryDate__32RZ9","footer":"styles_footer__1ZXBZ"};